export default __webpack_public_path__ + "static/media/Group457@2x.2d7d81b2.png";